
const dealerSelect = document.getElementById('dealerSelect');

document.addEventListener('DOMContentLoaded', () => {
    if (dealerSelect) {
        dealerSelect.addEventListener('change', dealerChangeHandler);
    }
});

const renderDealers = async (zipCode) => {
    const dealers = await getLocalDealers(zipCode);

    if (dealers && dealers.length > 0) {
        populateDealers(dealers);
    } else {
        populateDealers([]);
        vertiv.storage.remove('selectedDealerId');
    }
}

const getLocalDealers = async (zipCode) => {

    const dealers = await getLocalDealersFromApi(zipCode);
    // any transformation
    return dealers;

}

const populateDealers = (dealers) => {

    if (!dealerSelect) return;

    dealerSelect.innerHTML = '';

    if (dealers.length === 0) {
        dealerSelect.innerHTML = '<option value="">No dealers available</option>';
        return;
    }
    mapDealers(dealers);

}

const mapDealers = (dealers) => {
    dealers.forEach(dealer => {
        const option = document.createElement('option');
        option.value = dealer.dealerId;
        option.text = `${dealer.name} - ${dealer.address.city}`;
        dealerSelect.appendChild(option);
    });

    const savedDealerId = vertiv.storage.get('selectedDealerId');
    const defaultDealerId = savedDealerId && dealers.some(d => d.dealerId === savedDealerId)
        ? savedDealerId
        : dealers[0].dealerId;

    dealerSelect.value = defaultDealerId;

    vertiv.storage.set('selectedDealerId', defaultDealerId);
    // dealerSelect.value = dealers[0].dealerId;
}

const dealerChangeHandler = (dealer) => {
    const selectedDealerId = dealerSelect.value;

    if (selectedDealerId) {
        vertiv.storage.set('selectedDealerId', selectedDealerId);
    }
};

const getLocalDealersFromApi = async (zipCpde) => {

    const url = `/api/dealerLocator/${zipCpde}`; //todo: revisit

    // const res = await fetch(url, { method: 'GET' })
    // return res.json();

    return dealersMock[zipCpde]; //todo: remove mock
}



const dealersMock = {

    "02351": [
        {
            dealerId: "dealer-1",
            name: "Brockton Auto Hub",
            address: { address1: "700 Oak Street", city: "Brockton" },
            phoneNum: "9123456789",
            email: "contact@brocktonhub.com"
        },
        {
            dealerId: "dealer-2",
            name: "Weymouth Wheels",
            address: { address1: "740 Middle Street", city: "Weymouth" },
            phoneNum: "9123456789",
            email: "info@weymouthwheels.com"
        }
    ],
    "02019": [
        {
            dealerId: "dealer-3",
            name: "Smithfield Motors",
            address: { address1: "7 Dowling Village Blvd", city: "North Smithfield" },
            phoneNum: "9123456789",
            email: "sales@smithfieldmotors.com"
        },
        {
            dealerId: "dealer-4",
            name: "Whitinsville Auto Mall",
            address: { address1: "100 Valley Parkway", city: "Whitinsville" },
            phoneNum: "9123456789",
            email: "info@whitinsvilleauto.com"
        },
        {
            dealerId: "dealer-5",
            name: "Walpole Car Center",
            address: { address1: "550 Providence Highway", city: "Walpole" },
            phoneNum: "9123456789",
            email: "contact@walpolecenter.com"
        }
    ],
    "02322": [
        {
            dealerId: "dealer-6",
            name: "Avon Drive Autos",
            address: { address1: "30 Memorial Drive", city: "Avon" },
            phoneNum: "9123456789",
            email: "info@avondrive.com"
        },
        {
            dealerId: "dealer-7",
            name: "Abington Auto Plaza",
            address: { address1: "777 Brockton Avenue", city: "Abington" },
            phoneNum: "9123456789",
            email: "sales@abingtonplaza.com"
        },
        {
            dealerId: "dealer-8",
            name: "Weymouth Car Gallery",
            address: { address1: "740 Middle Street", city: "Weymouth" },
            phoneNum: "9123456789",
            email: "contact@weymouthgallery.com"
        },
        {
            dealerId: "dealer-9",
            name: "Bellingham Auto Spot",
            address: { address1: "250 Hartford Avenue", city: "Bellingham" },
            phoneNum: "9123456789",
            email: "info@bellinghamspot.com"
        }
    ],
    "29405": [
        {
            dealerId: "dealer-1",
            name: "ABC Center",
            address: { address1: "123 phoenix", city: "Cambridge" },
            phoneNum: "9123456789",
            email: "contact@center.com"
        },
        {
            dealerId: "dealer-2",
            name: "XYZ Motors",
            address: { address1: "200 ave ", city: "San Francisco" },
            phoneNum: "9123456789",
            email: "info@motors.com"
        }
    ],
    "29418": [
        {

            dealerId: "dealer-1",
            name: "ABC Center",
            address: { address1: "123 Phoenix St", city: "Boston" },
            phoneNum: "6175551234",
            email: "contact@center.com"

        }
    ],
    "29406": [
        {

            dealerId: "dealer-1",
            name: "ABC Center",
            address: { address1: "123 Phoenix St", city: "California" },
            phoneNum: "6175551234",
            email: "contact@center.com"

        }
    ]
};